import { render } from "./CommonTableComponent.vue?vue&type=template&id=18b42e93&scoped=true"
import script from "./CommonTableComponent.vue?vue&type=script&lang=js"
export * from "./CommonTableComponent.vue?vue&type=script&lang=js"

import "./CommonTableComponent.vue?vue&type=style&index=0&id=18b42e93&scoped=true&lang=css"
import "./CommonTableComponent.vue?vue&type=style&index=1&id=18b42e93&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b42e93"]])

export default __exports__